export default __webpack_public_path__ + "static/media/Plats_Suppression.37dfe75d.png";